import { useMutation } from 'react-query';

import { unfinalProject } from 'shared/api/projects/http';

const useMutateUnfinalProject = (options = undefined) => useMutation((id) => unfinalProject(id), options);

export default useMutateUnfinalProject;
